import React from 'react';
import './ModalTemplateA.scss';
import Modal from 'react-modal';
import { customStyles } from '../../../view/styles/customStyles';

const ModalTemplateA = (props) => {
  const { isOpen, icon, closeModal, title, description, children, shouldCloseOnOverlayClick = true } = props || {};
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={closeModal}
      style={customStyles}
      overlayClassName="modal-overlay-style"
      ariaHideApp={false}
      shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
    >
      <div className="modal-template-A">
        {icon && <img src={icon} alt="!" className="modal-template-A-icon" />}
        <div className="modal-template-A-header" style={{ border: description && 'none', paddingBottom: description && 0, marginBottom: description && 20 }}>
          {title}
        </div>
        {description && <div className="modal-template-A-description">{description}</div>}
        <div className="modal-template-A-content">{children}</div>
      </div>
    </Modal>
  );
};

export default ModalTemplateA;
